import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito ser experta en crochet?',
  a: 'No, necesitas un nivel intermedio. Si ya sabes hacer anillo mágico, puntos bajos, aumentos y disminuciones, podrás seguir los patrones perfectamente. Explicamos todo paso a paso.'
}, {
  q: '¿Cómo recibo el ebook?',
  a: 'Es un producto 100% digital. Inmediatamente después de tu pago, recibirás un correo electrónico con el enlace de descarga directa en formato PDF.'
}, {
  q: '¿Puedo vender los amigurumis que teja?',
  a: '¡Sí, totalmente! De hecho, alentamos a las emprendedoras a usar estos diseños. Lo único que no puedes vender o compartir es el patrón (el archivo PDF) en sí mismo.'
}, {
  q: '¿Están en español?',
  a: 'Sí, todo el contenido está redactado en español neutro, con términos claros y universales del crochet.'
}, {
  q: '¿Qué pasa si tengo dudas al tejer?',
  a: 'El ebook es muy detallado, pero si te trabas en algún paso, puedes escribirnos al correo de soporte incluido en tu compra y te ayudaremos con gusto.'
}, {
  q: '¿Hay garantía?',
  a: 'Sí, tienes 7 días de garantía de satisfacción. Si el ebook no cumple tus expectativas, te devolvemos tu dinero sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-white" data-id="element-82">
      <div className="max-w-3xl mx-auto px-4" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-84">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown" data-id="element-85">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-86">
          {faqs.map((faq, index) => <div key={index} className="etsy-card overflow-hidden" data-id="element-87">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-88">
                <span className="font-bold text-deep-brown text-sm pr-4" data-id="element-89">
                  {faq.q}
                </span>
                <ChevronDown size={18} className={`text-warm-brown flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-90" />
              </button>
              <AnimatePresence data-id="element-91">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-92">
                    <div className="px-5 pb-5 text-gray-500 leading-relaxed text-sm border-t border-gray-50 pt-4" data-id="element-93">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}